import { SortingState } from '@tanstack/react-table';

import { Nullable, PageViewModel, ServerResponse, SubmissionStatus } from '@/types';

export type AiresFilesDataParams = {
  page: number;
  orderBy: SortingState;
  take: number;
};

export type AiresFileData = {
  documentDate: string;
  failureReason: string;
  loanFileName: string;
  shareFileName: string;
  isAiresPlus: Nullable<boolean>;
  status: SubmissionStatus;
  submissionId: number;
  submittedAt: string;
};

export enum AiresFilesTableColumns {
  loanFileName = 'loanFileName',
  submissionId = 'submissionId',
  isAiresPlus = 'isAiresPlus',
  documentDate = 'documentDate',
  submittedAt = 'submittedAt',
  status = 'status',
}

export type AiresFilesData = {
  count: number;
  pageViewModel: PageViewModel;
  tableData: AiresFileData[];
  timeGenerated: string;
};

export type AiresFilesStatuses = {
  submissionId: number;
  status: SubmissionStatus;
};

export type AiresFilesResponse = ServerResponse<AiresFilesData>;
export type AiresFilesStatusesResponse = ServerResponse<AiresFilesStatuses[]>;

export type AiresFilesIds = AiresFileData['submissionId'][];
export type SubmissionDataState = { fileName: string; submissionId: AiresFileData['submissionId'] };

export type DataQualityRow = {
  columnName: string;
  formattedEmptyRowsNumber: string;
  emptyPercentage: string;
  formattedInvalidRowsNumber: string;
  invalidPercentage: string;
  impactOn: string;
};

export type CodeMappingRow = {
  columnName: string;
  formattedIssueNumber: string;
  issuePercentageValue: string;
  impactOn: string;
  issuePercentage: number;
};

export type GeneralDataQualityRow = {
  columnName: string;
  formattedAIRESValue: string;
  formattedCallReportValue: string;
  match: string;
  callReportDate: string;
};

export type ProductTypesRow = {
  columnName: string;
  formattedAIRESCount: string;
  formattedCallReportCount: string;
  countMatch: string;
  formattedAIRESSum: string;
  formattedCallReportSum: string;
  sumMatch: string;
};

export type ProductComparisonType = 'loan' | 'share';

export type AiresComparisonRow = {
  columnName: string;
  documentDate: string;
  formattedCurrentValue: string;
  formattedPreviousValue: string;
  match: string;
};

export type AiresValidationResult = {
  loanDataQuality: DataQualityRow[];
  shareDataQuality: DataQualityRow[];
  loanShareCodeMappingQuality: CodeMappingRow[];
  airesVsCallReport: {
    callReportDate: string;
    generalDataQuality: GeneralDataQualityRow[];
    loanProductTypes: ProductTypesRow[];
    shareProductTypes: ProductTypesRow[];
  };
  currentAiresVsPreviousAires: AiresComparisonRow[];
};

export type AiresValidationResponse = ServerResponse<AiresValidationResult>;
